import React from 'react';
import { Box } from '@mui/material';

interface WavesDividerProps {
  color?: string;
  flip?: boolean;
  height?: number;
}

export const WavesDivider = React.memo(function WavesDivider({
  color = '#E5E7EB',
  flip = false,
  height = 60,
}: WavesDividerProps) {
  return (
    <Box
      aria-hidden="true"
      role="presentation"
      sx={{
        width: '100%',
        height,
        overflow: 'hidden',
        lineHeight: 0,
        transform: flip ? 'rotate(180deg)' : 'none',
      }}
    >
      <svg
        viewBox="0 0 1200 60"
        preserveAspectRatio="none"
        style={{ width: '100%', height: '100%', display: 'block' }}
      >
        <path
          d="M0,30 C200,60 400,0 600,30 C800,60 1000,0 1200,30 L1200,60 L0,60 Z"
          fill={color}
          fillOpacity={0.15}
        />
        <path
          d="M0,40 C300,55 500,20 700,40 C900,55 1100,25 1200,40 L1200,60 L0,60 Z"
          fill={color}
          fillOpacity={0.08}
        />
      </svg>
    </Box>
  );
});
